/**
 * Runtime configuration.
 *
 * Production containers generate `/config.js` from environment variables at start-up
 * (`entrypoint.sh`), so one image serves every environment. In development `public/config.js`
 * holds the defaults and the Vite `VITE_*` variables are the fallback for both.
 */
export interface RuntimeConfig {
  /** Keycloak realm URL, e.g. `https://sso.example.cz/realms/bvk/`. */
  authority: string;
  /** Public OIDC client id registered for this frontend. */
  clientId: string;
  /** Backend base URL including the `/api/v1` prefix. */
  apiUrl: string;
}

const windowConfig: Partial<AppConfig> = typeof window === 'undefined' ? {} : (window.__APP_CONFIG__ ?? {});

/** Read a value from `config.js`, falling back to the build-time Vite variable. */
const pick = (runtime: string | undefined, buildTime: string | undefined, fallback: string): string =>
  runtime && runtime.trim() !== '' ? runtime : buildTime && buildTime.trim() !== '' ? buildTime : fallback;

export const runtimeConfig: RuntimeConfig = {
  authority: pick(windowConfig.VITE_AUTHORITY, import.meta.env.VITE_AUTHORITY, 'http://localhost:8080/realms/test/'),
  clientId: pick(windowConfig.VITE_CLIENT_ID, import.meta.env.VITE_CLIENT_ID, 'test-app'),
  apiUrl: pick(windowConfig.VITE_API_URL, import.meta.env.VITE_API_URL, 'http://localhost:5000/api/v1'),
};
